import InsightsIcon from "@mui/icons-material/Insights";

import { registerNavSection } from "./shell/navigation";

registerNavSection({ key: "planning", spoke: "planning", title: "Planning", icon: InsightsIcon, order: 42, entries: [
  { label: "MRP workbench", to: "/app/planning/mrp", permission: "planning.mrp.view" },
  { label: "Forecasts", to: "/app/planning/forecasts", permission: "planning.forecast.view" },
  { label: "Master schedule (MPS)", to: "/app/planning/mps", permission: "planning.mps.view" },
  { label: "Planning parameters", to: "/app/masterdata/planning-parameters", permission: "planning.parameter.view" },
  { label: "Manual demand", to: "/app/masterdata/manual-demand", permission: "planning.demand.view" },
] });
